





























































































































































































































import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import {checkMobile, getPassAnswer} from '../../utils/utils'
import ChartProgress from '../atoms_molecules/ChartProgress.vue'
import ExamResultQuestionGroupList from '../atoms_molecules/ExamResultQuestionGroupList.vue'
import {ROUTER_NAME} from '../../router'
import SlideBar from '../atoms_molecules/SlideBar.vue'
import {filter, find, map} from 'lodash'
import Question from '../../models/question'
import {LETTER_FORMAT} from '../../utils/constants'
import {ExamResultQuestion, GroupQuestion} from '../../../api/v2/models/question'
import ExamResultQuestionBodyWeb from '../atoms_molecules/ExamResultQuestionBodyWeb.vue'
import ExamResultQuestionBodyMobile from '../atoms_molecules/ExamResultQuestionBodyMobile.vue'
import {FooterData, ButtomItemData, footerState} from '../../stores/footer'
import hotkeys from 'hotkeys-js'
import {headerState} from '../../stores/header'
import api from '../../../api/v2/api'
import Banner from '../../../api/v2/models/banner'
import {userState} from '../../stores/user'
import {examResultState} from '../../stores/exam_result'
import Exam from '../../models/exam'
import MesageContainer from "../organisms/MesageContainer.vue";
import ThreadContainer from "../organisms/ThreadContainer.vue";
import {Multipane, MultipaneResizer} from 'vue-multipane'

@Component({
  components: {
    ThreadContainer,
    MesageContainer,
    ChartProgress,
    ExamResultQuestionGroupList,
    SlideBar,
    ExamResultQuestionBodyWeb,
    ExamResultQuestionBodyMobile,
    Multipane,
    MultipaneResizer,
  }
})
export default class ExamResultMain extends Vue {
  //To Fix bug  https://github.com/happa/skillhub/issues/719
  isShowBody = true
  LETTER_FORMAT = LETTER_FORMAT
  mobile: boolean = checkMobile()
  tabSelected = null
  totalPass: number = 0
  reRender: string = Date().toString()
  banners: Banner[] = []
  currentGroupQuestion: GroupQuestion = null
  footerMobile: FooterData = {
    color: '#7DD420',
    show: true,
    default: {
      show: false
    },
    buttons: {
      show: true,
      items: []
    }
  }
  questionNumber: number = 0
  tab: number | null = null

  resizeOb: ResizeObserver = null

  updated() {
    this.$nextTick(function () {
      if (this.resizeOb) return

      const observeSidebar = () => {
        const rightSideBar = this.$refs.rightSideBar as HTMLElement
        const rightSideBarCard = this.$refs.rightSideBarCard as any
        this.resizeOb = new ResizeObserver(function(entries) {
          let rect = entries[0].contentRect;
          let width = rect.width;
          rightSideBarCard.$el.style.width = `${width}px`
        })
        this.resizeOb.observe(rightSideBar)
      }

      const retryObserveSidebar = () => {
        try {
          observeSidebar()
        } catch (error) {
          setTimeout(retryObserveSidebar, 500)
        }
      }

      setTimeout(retryObserveSidebar, 500)
    })
  }

  beforeUnmount() {
    const rightSideBar = this.$refs.rightSideBar as HTMLElement
    this.resizeOb.unobserve(rightSideBar)
  }

  get schoolSetting() {
    return headerState.schoolSetting
  }

  get exam() {
    return examResultState.examResult
  }

  get user() {
    return userState.user
  }

  get questionId() {
    return Number(this.$route.params.questionId)
  }

  get examQScoreHistory() {
    return examResultState.examQScoreHistory
  }

  get userExam() {
    if (this.userExamId) {
      return this.exam.userExams.find((userExam) => `${userExam.id}` == this.userExamId)
    }
    return this.exam.userExam
  }

  get redirectNotFoundPage() {
    return examResultState.redirectNotFoundPage
  }

  getQuestionNumber(groupExamResultQuestion) {
    return (
        this.groupQuestions
            .filter((item) => item.questions.every((question) => !question.isDescriptionQuestion))
            .indexOf(groupExamResultQuestion) + 1
    )
  }

  @Watch('exam')
  @Watch('examResultQuestions')
  changeExam(val) {
    this.updateData(this.exam, this.$route)
  }

  @Watch('$route', {immediate: true})
  onRouteChanged(val) {
    this.isShowBody = false
    setTimeout(() => {
      this.isShowBody = true
      window.scrollTo(0, 0)
    }, 100)

    if (this.mobile) {
      var date = new Date()
      this.reRender = date.getTime().toString()
    }
    this.updateData(this.exam, val)
  }

  @Watch('redirectNotFoundPage')
  changeRedirectNotFoundPage(val, oldVal) {
    if (val) {
      examResultState.setRedirectNotFoundPage({status: false})
      this.redirectToNotFoundPage()
    }
  }

  @Watch('questionId')
  async onQuestionIdChanged() {
    await examResultState.requestExamGroupQuestion(Number(this.$route.params.questionId))
    this.currentGroupQuestion = examResultState.groupQuestions.find((item) => item.groupId == examResultState.currentGroupQuestion.groupId)
  }

  redirectToNotFoundPage() {
    this.$router.push({
      name: ROUTER_NAME.NOT_FOUND
    })
  }

  get maxScore(): number {
    return this.currentGroup.maxScore
  }

  get score(): number {
    return this.currentGroup.getScoreByUserExam(this.userExam)
  }

  get isPass() {
    return this.score === this.maxScore
  }

  get isNotFullScore() {
    return this.score < this.maxScore && this.score > 0
  }

  get isNotPass() {
    return this.score === 0
  }

  get currentIndex(): number {
    if (!this.currentGroup) {
      return -1
    }
    const notDescriptionGroups = this.groupQuestions.filter((item) => !item.isDescriptionQuestion)
    return notDescriptionGroups
        .map(e => e.groupId)
        .indexOf(this.currentGroup.groupId) + 1;

    // return notDescriptionGroups.indexOf(this.currentGroupQuestion) + 1
  }

  get currentGroup(): GroupQuestion | null {
    return examResultState.currentGroupQuestion
  }

  get currentDeGroup(): GroupQuestion {
    return examResultState.currentGroupQuestion
  }

  get sortedgroupQuestions() {
    return this.groupQuestions.sort((a, b) => a.groupId - b.groupId)
  }

  get groupQuestions() {
    return examResultState.groupQuestions
  }

  get examResultQuestions() {
    return examResultState.examResultQuestions
  }

  get currentQuestion(): ExamResultQuestion {
    return this.examResultQuestions.find((item) => item.id == parseInt(this.$route.params.questionId))
  }

  get isLastItem() {
    const groupIndex = this.groupQuestions.indexOf(this.currentGroupQuestion)
    return groupIndex === this.groupQuestions.length - 1
  }

  get isFirstItem() {
    const groupIndex = this.groupQuestions.indexOf(this.currentGroupQuestion)
    return groupIndex === 0
  }

  get userExamId() {
    return this.$route.query.user_exam_id as string
  }

  updateData(exam: Exam, route) {
    this.tabSelected = parseInt(route.params.questionId)
    if (exam && this.examResultQuestions && this.examResultQuestions.length) {
      if (!this.currentQuestion) {
        this.redirectToNotFoundPage()
      }
      const question = find(this.examResultQuestions, ['id', parseInt(route.params.questionId)])
      if (question) {
        this.totalPass = getPassAnswer(question.answerItems)
        const passAnswers = filter(this.userExam.answers, {
          qId: parseInt(route.params.questionId),
          correct: true
        })
      }
      if (this.mobile) {
        this.footerMobile.buttons.items = this.getFooterItems(exam.questions.length)
        footerState.setFooter({...this.footerMobile})
      }
    }
  }

  getFooterItems(count): ButtomItemData[] {
    return [
      {
        color: 'white',
        round: true,
        label: '＜＜',
        action: this.first,
        disabled: this.isFirstItem
      },
      {
        color: 'white',
        round: true,
        label: '＜',
        action: this.previous,
        disabled: this.isFirstItem
      },
      {
        icon: '',
        round: false,
        spacer: true,
        color: '',
        label: ''
      },
      {
        round: true,
        color: 'white',
        label: '＞',
        action: this.next,
        disabled: this.isLastItem
      },
      {
        round: true,
        color: 'white',
        label: '＞＞',
        action: this.last,
        disabled: this.isLastItem
      }
    ]
  }

  async created() {
    try {
      this.banners = await Promise.resolve(api.banner.index({type: "question_result"}),
      )
    } catch (e) {
    }
  }

  getBanner(position) {
    var result = this.banners.find(banner => {
      return banner.position == position
    })
    return result
  }

  public mounted() {
    if (this.exam) {
      this.updateData(this.exam, this.$route)
    }
    examResultState.requestExamResult(parseInt(this.$route.params.examId)).then(() => {
      examResultState.setUserExamId(Number(this.userExamId))
      examResultState.getExamResultQuestions()
      examResultState.requestExamGroupQuestion(Number(this.$route.params.questionId))
      examResultState.requestExamQScoreHistories(parseInt(this.$route.params.examId))
    })

    if (examResultState.currentGroupQuestion) {
      this.currentGroupQuestion = examResultState.groupQuestions.find((item) => item.groupId === examResultState.currentGroupQuestion.groupId)
    }
    
    this.tabSelected = parseInt(this.$route.params.questionId)
    headerState.setTitle(this.$t('common.answer', {format: LETTER_FORMAT.UPTITLECASE}) as string)
    this.settupHotKeys()
  }

  settupHotKeys() {
    this.removeHotkeys()

    hotkeys.filter = (event) => {
      return true
    }

    hotkeys('ctrl+shift+right, control+shift+right, option+right', 'exams', () => {
      this.next()
    })

    hotkeys('alt+shift+right', 'exams', () => {
      this.last()
    })

    hotkeys('ctrl+shift+left, control+shift+left, option+left', 'exams', () => {
      return this.previous()
    })

    hotkeys('alt+shift+left', 'exams', () => {
      this.first()
    })

    hotkeys.setScope('exams')
  }

  removeHotkeys() {
    hotkeys.deleteScope('exams')
  }

  beforeDestroy() {
    this.removeHotkeys()
  }

  backToExamResult() {
    this.$router.push({
      name: ROUTER_NAME.EXAM_RESULT,
      params: {
        examId: this.$route.params.examId
      },
      query: this.$route.query
    })
  }

  getSkillsName(skills) {
    return map(skills, 'name').join(', ')
  }

  next() {
    if (this.isLastItem) {
      return
    }
    const groupIndex = this.groupQuestions.map(function (e) {
      return e.groupId;
    }).indexOf(this.currentGroup.groupId)
    this.goQuestion(this.groupQuestions[groupIndex + 1].questions[0])
  }

  previous() {
    if (this.isFirstItem) {
      return
    }
    const groupIndex = this.groupQuestions.map(function (e) {
      return e.groupId;
    }).indexOf(this.currentGroup.groupId)
    this.goQuestion(this.groupQuestions[groupIndex - 1].questions[0])
  }

  first() {
    this.goQuestion(this.groupQuestions[0].questions[0])
  }

  last() {
    this.goQuestion(this.groupQuestions[this.groupQuestions.length - 1].questions[0])
  }

  goQuestion(question: Question) {
    if (question.id != this.currentQuestion.id) {
      this.$router.push({
        name: ROUTER_NAME.ANSWER_RESULT_DETAIL,
        params: {
          examId: `${this.exam.id}`,
          questionId: `${question.id}`
        },
        query: this.$route.query
      })
    }
  }

  back() {
    this.$router.push({
      name: ROUTER_NAME.EXAM_RESULT,
      params: {
        examId: this.$route.params.examId
      },
      query: this.$route.query
    })
  }

  toResulQuestionLList() {
    this.$router.push({
      name: ROUTER_NAME.EXAM_RESULT_QUESTION_LIST,
      params: {
        examId: this.$route.params.examId
      },
      query: this.$route.query
    })
  }

  changeQuestion(slideIndex) {
    if (slideIndex > 1 && !this.isLastItem) {
      this.next()
    }
    if (slideIndex < 1 && !this.isFirstItem) {
      this.previous()
    }

    ;(this.$refs.swipe as any).goto(1)
  }

  updateParentTab(value: number) {
    this.tab = value
  }

  emitCreateThread(value: number) {
    if (typeof value === 'number') {
      this.tab = value;
    }
    (this.$refs.mesageContainer as any).createThread()
  }
}
